import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { fetchUsers, selectUsers } from "../users/usersSlice";
import { fetchCouriers, selectCouriers } from "../couriers/couriersSlice";
import OrderProducts from "./OrderProducts";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import { checkFieldUpdate } from "../../common/utils";

import DialogTitle from "@material-ui/core/DialogTitle";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import IconButton from "@material-ui/core/IconButton";

import { makeStyles, withStyles } from "@material-ui/core/styles";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

import Divider from "@material-ui/core/Divider";
import { Typography } from "@material-ui/core";
import {
  updateOrderDetails,
  updateOrderProduct,
  setEditing,
  setOrderUser,
  selectOrders,
  createOrder,
} from "./ordersSlice";

import { fetchProducts, selectProducts } from "../products/productsSlice.js";

const useStyles = makeStyles((theme) => ({
  // #42494E; light blue
  // #131f47; dark blue
  // #ed5e9d; pink
  tabBar: {
    // backgroundColor: ' rgba(0, 0, 0, 0.08)',
  },
  paper: {
    display: "flex",
    flexDirection: "column",
    // alignItems: 'center',
    borderRadius: "10px",
    backgroundColor: "#FFF",
    padding: 0,
  },
  heading: {},
  form: {
    // width: '100%', // Fix IE 11 issue.
    // marginTop: theme.spacing(1),
    // padding: 25,
  },
  linkText: {
    fontSize: 16,
    display: "flex",
    alignItems: "center",
  },
  headerContainer: {
    padding: theme.spacing(2),
    // color: '#fafafa',
    color: "#fff",
    backgroundColor: "#42494E",
  },
  subHeader: {
    margin: theme.spacing(2),
    marginBottom: 0,
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
    backgroundColor: "#42494E",
    color: "#FFF",
  },
  tabContent: {
    display: "flex",
    flexFlow: "column nowrap",
    flexGrow: 1,
  },
  root: {
    display: "flex",
  },

  outer: { display: "flex", flexFlow: "column" },
  addIcon: {
    marginRight: 8,
    color: "#fff",
  },
  title: {
    color: "#fff",
    padding: 16,
    backgroundColor: " #42494E",
    textAlign: "center",
    fontSize: 18,
    fontWeight: "bold",
  },
  textItem: {
    marginBottom: 16,
  },
}));

const ColorButton = withStyles((theme) => ({
  root: {
    // margin: theme.spacing(3, 0, 2),
    margin: theme.spacing(0, 0, 0),
    backgroundColor: "#D86D7E",
    color: "#FFF",
    "&:hover": {
      opacity: 0.9,
      backgroundColor: "#D86D7E",
    },
    width: "100%",
    // fontWeight: 'bold',
  },
}))(Button);

export default function Orders(props) {
  const { product } = props;
  const classes = useStyles();
  // const edit = props.edit;
  const { user } = useSelector(selectUsers);
  const { couriersList } = useSelector(selectCouriers);
  const { orderUser, ordersList, editing, order } = useSelector(selectOrders);
  // const {productList} = useSelector(selectProducts);

  let jwtToken = localStorage.getItem("coreToken");
  const dispatch = useDispatch();

  const [open, setOpen] = useState(false);

  const [editOrder, setEditOrder] = useState(false);

  // cart
  const [orderNumber, setOrderNumber] = useState("");
  const [orderProducts, setOrderProducts] = useState([]);
  const [addedProducts, setAddedProducts] = useState([]);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [mobile, setMobile] = useState("");
  const [email, setEmail] = useState("");
  const [streetNumber, setStreetNumber] = useState("");
  const [streetName, setStreetName] = useState("");
  const [suburb, setSuburb] = useState("");
  const [postCode, setPostCode] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [country, setCountry] = useState("");
  const [notes, setNotes] = useState("");
  const [totalPoints, setTotalPoints] = useState(0);
  const [orderStatus, setOrderStatus] = useState("");

  const handleSubmit = (event) => {
    event.preventDefault();
    if (editOrder) {
      const updatedOrder = {
        statusID: orderStatus,
        billingAddress: {
          streetNumber: streetNumber,
          streetName: streetName,
          suburb: suburb,
          postCode: postCode,
          city: city,
          state: state,
          country: country,
        },
        deliveryAddress: {
          streetNumber: streetNumber,
          streetName: streetName,
          suburb: suburb,
          postCode: postCode,
          city: city,
          state: state,
          country: country,
        },
        notes: notes,
      };

      const updatedOrderBillingAddressFields = checkFieldUpdate(
        [
          { name: "streetNumber", val: streetNumber },
          { name: "streetName", val: streetName },
          { name: "suburb", val: suburb },
          { name: "postCode", val: postCode },
          { name: "city", val: city },
          { name: "state", val: state },
          { name: "country", val: country },
        ],
        order.billingAddress
      );
      const updatedOrderDeliveryAddressFields = checkFieldUpdate(
        [
          { name: "streetNumber", val: streetNumber },
          { name: "streetName", val: streetName },
          { name: "suburb", val: suburb },
          { name: "postCode", val: postCode },
          { name: "city", val: city },
          { name: "state", val: state },
          { name: "country", val: country },
        ],
        order.deliveryAddress
      );

      let baseUpdateOrderFields = [
        { name: "statusID", val: orderStatus },
        { name: "notes", val: notes },
      ];

      if (Object.keys(updatedOrderDeliveryAddressFields).length !== 0) {
        baseUpdateOrderFields.push({
          name: "deliveryAddress",
          val: updatedOrderDeliveryAddressFields,
        });
      }
      if (Object.keys(updatedOrderBillingAddressFields).length !== 0) {
        baseUpdateOrderFields.push({
          name: "billingAddress",
          val: updatedOrderBillingAddressFields,
        });
      }
      const updatedOrderFields = checkFieldUpdate(baseUpdateOrderFields, order);

      // if (order.products !== orderProducts) {
      orderProducts.forEach((prod) => {
        let match = order.products.filter(
          (op) => op.productID === prod.productID
        );

        const updatedOrderProductFields = checkFieldUpdate(
          [
            { name: "statusID", val: prod.statusID },
            { name: "notes", val: prod.notes },
            { name: "courierCompanyID", val: prod.courierCompanyID },
            { name: "courierTrackingID", val: prod.courierTrackingID },
          ],
          match[0]
        );

        if (Object.keys(updatedOrderProductFields).length !== 0) {
          dispatch(
            updateOrderProduct({
              token: jwtToken,
              orderID: order.id,
              productID: prod.productID,
              product: updatedOrderProductFields,
              clientID: order.clientID,
            })
          );
        }
      });

      if (Object.keys(updatedOrderFields).length !== 0) {
        dispatch(
          updateOrderDetails({
            token: jwtToken,
            orderID: order.id,
            order: updatedOrderFields,
            clientID: order.clientID,
          })
        );
      }
    } else {
      const updatedProducts = addedProducts.map((prod) => {
        return {
          productID: prod.id,
          quantity: prod.quantity ? Number(prod.quantity) : 1,
          notes: prod.notes ? prod.notes : "",
        };
      });

      const order = {
        statusID: 5,
        userID: orderUser.id,
        billingAddress: {
          streetNumber: streetNumber,
          streetName: streetName,
          suburb: suburb,
          postCode: postCode,
          city: city,
          state: state,
          country: country,
        },
        deliveryAddress: {
          streetNumber: streetNumber,
          streetName: streetName,
          suburb: suburb,
          postCode: postCode,
          city: city,
          state: state,
          country: country,
        },
        userPoints: 10000,
        products: updatedProducts,
        notes: notes,
      };

      dispatch(
        createOrder({
          token: jwtToken,
          order: order,
          clientID: order.clientID,
        })
      );
    }
  };

  useEffect(() => {
    if (!couriersList.length && editing) {
      dispatch(
        fetchCouriers({
          token: jwtToken,
          query: "",
        })
      );
    }
  }, [dispatch]);

  useEffect(() => {
    // opens dialog after list order has been loaded
    if (editing && order !== {}) {
      setEditOrder(true); //temp
      setOrderStatus(order.statusID);
      setOpen(true);
      setOrderNumber(order.id);
      if (orderUser) {
        setFirstName(orderUser.firstName);
        setLastName(orderUser.lastName);
        setMobile(order.userMobile);
        setEmail(order.userEmail);
      }

      if (order.deliveryAddress) {
        setStreetNumber(order.deliveryAddress.streetNumber);
        setStreetName(order.deliveryAddress.streetName);
        setSuburb(order.deliveryAddress.suburb);
        setPostCode(order.deliveryAddress.postCode);
        setCity(order.deliveryAddress.city);
        setState(order.deliveryAddress.state);
        setCountry(order.deliveryAddress.country);
      }
      setNotes(order.notes);
      setOrderProducts(order.products || []);
      setTotalPoints(order.totalPoints);
    }
    // console.log("order", order);
    // console.log("orderUser", orderUser);
  }, [editing, user]);

  useEffect(() => {
    // opens dialog after list order has been loaded
    if (orderUser) {
      setFirstName(orderUser.firstName);
      setLastName(orderUser.lastName);
      setMobile(orderUser.mobile);
      setEmail(orderUser.email);
    }
  }, [orderUser]);

  const handleClickOpen = () => {
    setEditOrder(false);
    dispatch(setEditing(false));
    setOrderNumber("");
    setFirstName("");
    setLastName("");
    setMobile("");
    setEmail("");
    setStreetNumber("");
    setStreetName("");
    setSuburb("");
    setPostCode("");
    setCity("");
    setState("");
    setCountry("");
    setOrderProducts([]);
    setTotalPoints("");
    setNotes("");
    setOrderStatus("");
    setOpen(true);
  };

  const handleClose = () => {
    dispatch(setEditing(false));
    setOrderNumber("");
    setFirstName("");
    setLastName("");
    setMobile("");
    setEmail("");
    setStreetNumber("");
    setStreetName("");
    setSuburb("");
    setPostCode("");
    setCity("");
    setState("");
    setCountry("");
    setOrderProducts([]);
    setTotalPoints("");
    setNotes("");
    setOrderStatus("");
    setOpen(false);
    setEditOrder(false);
  };

  // l;j;jkl
  const [checked, setChecked] = useState([0]);
  const handleToggle = (value) => () => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setChecked(newChecked);
  };

  const [search, setSearchTerm] = useState("");
  const [selectedUser, setUser] = useState(1);

  const handleUserClick = (event, index) => {
    setUser(index);
  };
  const [userSearch, setUserSearch] = useState("");

  const updateProducts = (prods) => {
    setAddedProducts(prods);
  };

  const handleUserSelect = (user) => {
    dispatch(setOrderUser(user));
  };
  const [removeID, setRemoveID] = useState([]);
  const handleRemove = (evt) => {
    setRemoveID(Number(evt.target.value));
  };

  const handleRemoveOrderProducts = (evt, id) => {
    const updatedProds = orderProducts.filter((prod) => prod.productID !== id);
    setOrderProducts(updatedProds);
  };

  const [statusName, setStatusName] = useState([]);
  const [productQuantities, setProductQuantities] = useState([]);
  const [productNotes, setProductNotes] = useState([]);
  const [productsStatus, setProductsStatus] = useState([]);
  const [statusID, setStatusID] = useState([]);
  const [statusList, setStatusList] = useState([
    // { id: 1, value: "Active", name: "Active", isDisabled: true },
    { id: 16, value: "Dispatched", name: "Dispatched" },
    { id: 9, value: "Completed", name: "Completed" },
    { id: 23, value: "Refunded", name: "Refunded" },
    { id: 24, value: "Processing", name: "Processing", isDisabled: true },
  ]);
  const handleStatusChange = (event) => {
    let idsArr = [];
    let selectedStatus = statusList.filter(
      (status) => status.name === event.target.value
    );
    selectedStatus[0] && idsArr.push(selectedStatus[0].id);

    setStatusName(event.target.value);
    setStatusID(idsArr);
  };

  const handleStatusUpdate = () => {
    let jwtToken = localStorage.getItem("coreToken");

    // );
  };
  const handleProductUpdate = () => {};
  const handleUpdateStatus = (e, id) => {
    if (e.target.value == 23) {
      const allRefunded = orderProducts
        .filter((product) => product.productID !== id)
        .some((product) => product.statusID !== 23);
      if (!allRefunded) {
        setOrderStatus(23);
      } else {
        setOrderProducts((previousProducts) =>
          previousProducts.map((prod) => {
            return prod.productID === id
              ? { ...prod, statusID: e.target.value }
              : prod;
          })
        );
      }
    } else {
      setOrderProducts((previousProducts) =>
        previousProducts.map((prod) => {
          return prod.productID === id
            ? { ...prod, statusID: e.target.value }
            : prod;
        })
      );
    }
  };

  const handleUpdateCourier = (e, id) => {
    setOrderProducts((previousProducts) =>
      previousProducts.map((prod) => {
        return prod.productID === id
          ? { ...prod, courierCompanyID: e.target.value }
          : prod;
      })
    );
  };

  const handleUpdateTracking = (e, id) => {
    setOrderProducts((previousProducts) =>
      previousProducts.map((prod) => {
        return prod.productID === id
          ? { ...prod, courierTrackingID: e.target.value }
          : prod;
      })
    );
  };

  const handleQuantityUpdate = (evt, id) => {
    setAddedProducts((previousProducts) =>
      previousProducts.map((prod) => {
        return prod.id === id ? { ...prod, quantity: evt.target.value } : prod;
      })
    );
  };

  const handleProductNotesUpdate = (evt, id) => {
    setAddedProducts((previousProducts) =>
      previousProducts.map((prod) => {
        return prod.id === id ? { ...prod, notes: evt.target.value } : prod;
      })
    );
  };

  const handleOrderProdsNotes = (evt, id) => {
    setOrderProducts((previousProducts) =>
      previousProducts.map((prod) => {
        return prod.productID === id
          ? { ...prod, notes: evt.target.value }
          : prod;
      })
    );
  };

  return (
    <div>
      <IconButton
        aria-label={editOrder ? "edit user" : "add user"}
        style={
          product
            ? { marginLeft: 0, display: "none" }
            : { marginLeft: 0, display: "none" }
        }
      >
        <AddCircleIcon
          style={
            product ? { marginRight: 0 } : { marginRight: 0, color: "#fff" }
          }
          onClick={handleClickOpen}
        />
      </IconButton>

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
        fullWidth={true}
        maxWidth="lg"
      >
        <DialogTitle
          disableTypography
          className={classes.title}
          id="form-dialog-title"
        >
          {editOrder ? `Edit Order #${order.id}` : "Create New Order"}
        </DialogTitle>

        <div style={{ padding: 24 }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: 24,
            }}
          >
            <div
              style={{
                fontSize: 18,
                fontWeight: "bold",
                color: "rgb(64, 132, 243)",
              }}
            >
              Order Status
            </div>
            <div style={{ marginLeft: 24 }}>
              <FormControl style={{ width: 150 }} margin="dense">
                <Select
                  variant="outlined"
                  defaultValue={order.statusID}
                  margin="dense"
                  isDisabled={(e) => e.target.isDisabled}
                  onChange={(e) => setOrderStatus(e.target.value)}
                  inputProps={{
                    name: "status",
                    id: "status-simple",
                  }}
                >
                  {[
                    // {
                    //   id: 1,
                    //   value: "Active",
                    //   name: "Active",
                    //   disabled: true,
                    // },
                    {
                      id: 5,
                      value: "Pending",
                      name: "Pending",
                      isDisabled: true,
                    },
                    { id: 16, value: "Dispatched", name: "Dispatched" },
                    { id: 23, value: "Refunded", name: "Refunded" },
                    {
                      id: 24,
                      value: "Processing",
                      name: "Processing",
                      // isDisabled: true,
                    },
                    { id: 9, value: "Completed", name: "Completed" },
                  ].map((status) => (
                    <option value={status.id} disabled={status.isDisabled}>
                      {status.name}
                    </option>
                  ))}
                </Select>
              </FormControl>
            </div>{" "}
          </div>

          <div
            style={{
              display: "flex",
              marginBottom: 24,
              flexDirection: "column",
            }}
          >
            <div
              style={{
                fontSize: 18,
                fontWeight: "bold",
                color: "rgb(64, 132, 243)",
                paddingTop: 10,
                paddingBottom: 10,
              }}
            >
              Order Details
            </div>
            <div style={{ marginLeft: 24 }}>
              <div
                style={{
                  display: "flex",
                }}
              >
                <div style={{ marginRight: 60 }}>
                  <div
                    style={{
                      fontSize: 24,
                      fontWeight: "bold",
                      marginBottom: 16,
                    }}
                    className={classes.header}
                  >
                    Member Info
                  </div>
                  <div className={classes.textLabel}>
                    Member Display Name:{" "}
                    <span style={{ fontWeight: "normal" }}>
                      {order.userDisplayName}
                    </span>
                  </div>
                  <div className={classes.textLabel}>
                    Email:{" "}
                    <span style={{ fontWeight: "normal" }}>
                      {order.userEmail}
                    </span>
                  </div>
                  <div className={classes.textLabel}>
                    Contact Number:{" "}
                    <span style={{ fontWeight: "normal" }}>
                      {order.userMobile}{" "}
                    </span>
                  </div>
                </div>
                <div>
                  <div
                    style={{
                      fontSize: 24,
                      fontWeight: "bold",
                      marginBottom: 16,
                    }}
                    className={classes.header}
                  >
                    Delivery Address
                  </div>
                  <Grid container direction="column">
                    <Grid item sm>
                      <div className={classes.textLabel}>
                        {
                          // (order.deliveryAddress ?  order.deliveryAddress.streetNumber : '') +
                          // ' ' +
                          order.deliveryAddress
                            ? order.deliveryAddress.streetName
                            : ""
                        }
                      </div>
                    </Grid>

                    <Grid item sm>
                      <div className={classes.textLabel}>
                        {order.deliveryAddress
                          ? order.deliveryAddress.suburb
                          : ""}{" "}
                      </div>
                    </Grid>

                    <Grid item sm>
                      <div className={classes.textLabel}>
                        {(order.deliveryAddress
                          ? order.deliveryAddress.city
                          : "") +
                          " " +
                          (order.deliveryAddress
                            ? order.deliveryAddress.postCode
                            : "")}
                      </div>
                    </Grid>
                  </Grid>
                </div>
              </div>
            </div>{" "}
          </div>

          {orderProducts && orderProducts.length > 0 && (
            <div>
              <div
                style={{
                  fontSize: 18,
                  fontWeight: "bold",
                  color: "rgb(64, 132, 243)",
                }}
              >
                Products
              </div>
              <OrderProducts
                handleStatusUpdate={handleStatusUpdate}
                handleStatusChange={handleStatusChange}
                handleOrderProdsNotes={handleOrderProdsNotes}
                orderProducts={orderProducts}
                status={productsStatus}
                handleUpdateStatus={handleUpdateStatus}
                handleUpdateCourier={handleUpdateCourier}
                handleUpdateTracking={handleUpdateTracking}
                couriersList={couriersList}
              />
            </div>
          )}
          {Object.keys(orderUser).length ? (
            <div key={orderUser.id}>
              <div
                style={{
                  fontSize: 18,
                  fontWeight: "bold",
                  marginBottom: 12,
                  color: "rgb(64, 132, 243)",
                }}
              >
                Member Details
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <div style={{ width: "100%" }}>
                  <div
                    className={classes.textLabel}
                    style={{ marginTop: 4, fontSize: 14 }}
                  >
                    First Name:{" "}
                  </div>
                  <TextField
                    size="small"
                    value={firstName}
                    defaultValue={firstName}
                    className={classes.textInput}
                    variant="outlined"
                    margin="dense"
                    required
                    fullWidth
                    id="firstName"
                    name="firstName"
                    autoComplete="firstName"
                    onChange={(e) => setFirstName(e.target.value)}
                  />
                </div>
                <div style={{ width: "100%", marginLeft: 24 }}>
                  <div
                    className={classes.textLabel}
                    style={{ marginTop: 4, fontSize: 14 }}
                  >
                    Surname:{" "}
                  </div>
                  <TextField
                    size="small"
                    defaultValue={lastName}
                    value={lastName}
                    className={classes.textInput}
                    variant="outlined"
                    margin="dense"
                    required
                    fullWidth
                    id="lastName"
                    name="lastName"
                    autoComplete="lastName"
                    onChange={(e) => setLastName(e.target.value)}
                  />
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <div style={{ width: "100%" }}>
                  <div
                    className={classes.textLabel}
                    style={{ marginTop: 4, fontSize: 14 }}
                  >
                    Mobile:{" "}
                  </div>
                  <TextField
                    size="small"
                    defaultValue={mobile}
                    value={mobile}
                    className={classes.textInput}
                    variant="outlined"
                    margin="dense"
                    required
                    fullWidth
                    id="mobile"
                    name="mobile"
                    autoComplete="mobile"
                    onChange={(e) => setMobile(e.target.value)}
                  />
                </div>
                <div style={{ width: "100%", marginLeft: 24 }}>
                  <div
                    className={classes.textLabel}
                    style={{ marginTop: 4, fontSize: 14 }}
                  >
                    Email:{" "}
                  </div>
                  <TextField
                    size="small"
                    defaultValue={email}
                    value={email}
                    className={classes.textInput}
                    variant="outlined"
                    margin="dense"
                    required
                    fullWidth
                    id="email"
                    name="email"
                    autoComplete="email"
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>
              </div>

              <div
                style={{
                  fontSize: 18,
                  fontWeight: "bold",
                  marginBottom: 12,
                  marginTop: 12,
                  color: "rgb(64, 132, 243)",
                }}
              >
                Delivery Address
              </div>
              <div>
                <div style={{ display: "flex", flexDirection: "row" }}>
                  <div style={{ width: "100%" }}>
                    <div
                      className={classes.textLabel}
                      style={{
                        marginTop: 4,
                        fontSize: 14,
                      }}
                    >
                      Street Number:{" "}
                    </div>
                    <TextField
                      size="small"
                      defaultValue={streetNumber}
                      className={classes.textItem}
                      variant="outlined"
                      margin="dense"
                      id="street-number-street"
                      type="text"
                      fullWidth
                      onChange={(e) => setStreetNumber(e.target.value)}
                    />
                  </div>
                  <div style={{ width: "100%", marginLeft: 24 }}>
                    <div
                      className={classes.textLabel}
                      style={{
                        marginTop: 4,
                        fontSize: 14,
                      }}
                    >
                      Street Name:{" "}
                    </div>
                    <TextField
                      size="small"
                      defaultValue={streetName}
                      className={classes.textItem}
                      variant="outlined"
                      margin="dense"
                      id="street-number-street"
                      type="text"
                      fullWidth
                      onChange={(e) => setStreetName(e.target.value)}
                    />
                  </div>
                </div>
                <div style={{ display: "flex", flexDirection: "row" }}>
                  <div style={{ width: "100%" }}>
                    <div
                      className={classes.textLabel}
                      style={{
                        marginTop: 4,
                        fontSize: 14,
                      }}
                    >
                      Suburb:{" "}
                    </div>
                    <TextField
                      size="small"
                      defaultValue={suburb}
                      className={classes.textItem}
                      variant="outlined"
                      margin="dense"
                      id="subarb-street"
                      type="text"
                      fullWidth
                      onChange={(e) => setSuburb(e.target.value)}
                    />
                  </div>
                  <div style={{ width: "100%", marginLeft: 24 }}>
                    <div
                      className={classes.textLabel}
                      style={{
                        marginTop: 4,
                        fontSize: 14,
                      }}
                    >
                      Post Code:{" "}
                    </div>
                    <TextField
                      size="small"
                      defaultValue={postCode}
                      className={classes.textItem}
                      variant="outlined"
                      margin="dense"
                      id="post-code-street"
                      type="text"
                      fullWidth
                      onChange={(e) => setPostCode(e.target.value)}
                    />
                  </div>
                </div>
                <div style={{ display: "flex", flexDirection: "row" }}>
                  <div style={{ width: "100%" }}>
                    <div
                      className={classes.textLabel}
                      style={{
                        marginTop: 4,
                        fontSize: 14,
                      }}
                    >
                      City:{" "}
                    </div>
                    <TextField
                      size="small"
                      defaultValue={city}
                      className={classes.textItem}
                      variant="outlined"
                      margin="dense"
                      id="city-street"
                      type="text"
                      fullWidth
                      onChange={(e) => setCity(e.target.value)}
                    />
                  </div>
                  <div style={{ width: "100%", marginLeft: 24 }}>
                    <div
                      className={classes.textLabel}
                      style={{
                        marginTop: 4,
                        fontSize: 14,
                      }}
                    >
                      State:{" "}
                    </div>
                    <TextField
                      size="small"
                      defaultValue={state}
                      className={classes.textItem}
                      variant="outlined"
                      margin="dense"
                      id="state-street"
                      type="text"
                      fullWidth
                      onChange={(e) => setState(e.target.value)}
                    />
                  </div>
                </div>
                <div style={{ display: "flex", flexDirection: "row" }}>
                  <div style={{ width: "100%" }}>
                    <div
                      className={classes.textLabel}
                      style={{
                        marginTop: 4,
                        fontSize: 14,
                      }}
                    >
                      Country:{" "}
                    </div>
                    <TextField
                      size="small"
                      defaultValue={country}
                      className={classes.textItem}
                      variant="outlined"
                      margin="dense"
                      id="country"
                      type="text"
                      fullWidth
                      onChange={(e) => setCountry(e.target.value)}
                    />
                  </div>
                  <div style={{ width: "100%", marginLeft: 24 }}></div>
                </div>
              </div>
            </div>
          ) : (
            <div></div>
          )}
          <div
            style={{
              fontSize: 18,
              fontWeight: "bold",

              marginTop: 12,
              color: "rgb(64, 132, 243)",
            }}
          >
            Delivery Notes
          </div>
          <div style={{ width: "100%" }}>
            <TextField
              size="small"
              minRows={4}
              multiline
              defaultValue={notes}
              className={classes.textItem}
              variant="outlined"
              margin="dense"
              id="country"
              type="text"
              fullWidth
              onChange={(e) => setNotes(e.target.value)}
            />
          </div>
          <form onSubmit={handleSubmit} className={classes.form}>
            <Divider />
            <DialogActions
              style={{ paddingLeft: 24, paddingRight: 24, paddingBottom: 16 }}
            >
              <Grid container spacing={2} direction="row">
                <Grid item sm>
                  <ColorButton onClick={handleClose} color="primary">
                    Cancel
                  </ColorButton>
                </Grid>
                <Grid item sm>
                  <ColorButton
                    type="submit"
                    // onClick={editOrder ? handleUpdate : handleCreate}
                    // onClick={handleSubmit}
                    color="secondary"
                  >
                    {editOrder ? "Update Order" : "Create Order"}
                  </ColorButton>
                </Grid>
              </Grid>
            </DialogActions>
          </form>
        </div>
      </Dialog>
    </div>
  );
}
